import React, { useEffect, useState } from 'react';
import { ESteps } from '../../../interfaces/invitation/ESteps';
import TemplateInvitation from './TemplateIntro';
import StayUpdated from '../../../components/shared/stay-updated/StayUpdated';
import { useAppDispatch } from '../../../app/hooks';
import { disableAll, enableAll, setFeatureState } from '../../../store/features/featuresSlices';
import AuthChatInput from '../../../components/shared/chat-input/AuthChatInput';
import ChatContent from '../chats/ChatContent';
import ChatHistory from '../history/ChatHistory';
import { useNavigate } from 'react-router-dom';
import Faqs from '../faqs/Faqs';
import { useGetCurrentUserQuery } from '../../../store/user/userApi';

const Invitation = () => {
	const { data: userInfo } = useGetCurrentUserQuery();
	const navigate = useNavigate();
	const [step, setStep] = useState<number>(1);
	const dispatch = useAppDispatch();

	const handleNext = () => {
		if (step < Object.keys(ESteps).length / 2) {
			if (step === ESteps.WELCOME)
				dispatch(setFeatureState({feature: 'searchBar', enabled: true}))
			else if (step === ESteps.SEARCH_IT)
				dispatch(setFeatureState({feature: 'newsSection', enabled: true}))
			else if (step === ESteps.ASK_AI){
				dispatch(setFeatureState({feature: 'sidebarTopics', enabled: true}))
				dispatch(setFeatureState({feature: 'historyTab', enabled: true}))
			}
			else if (step === ESteps.SAVED) {
				dispatch(setFeatureState({feature: 'homeTab', enabled: true}))
				dispatch(setFeatureState({feature: 'historyTab', enabled: false}))
			}
			else if (step === ESteps.PERSONALIZE) {
				dispatch(setFeatureState({feature: 'faqsTab', enabled: true}))
				dispatch(setFeatureState({feature: 'homeTab', enabled: false}))
				dispatch(setFeatureState({feature: 'historyTab', enabled: false}))
			}
			setStep(step + 1);
		}
		else {
			dispatch(enableAll())
			navigate('/')
		}
	}
	const handleSkip = () => {
		dispatch(enableAll())
		navigate('/')

	}

	useEffect(()=>{
		dispatch(disableAll())
	},[]);
	return (
		<>
			{step === ESteps.WELCOME && 
				<TemplateInvitation
					headerTitle='Welcome'
					titlePrefix=''
					title={`Hi ${userInfo?.data.name || ''}`}
					description='Welcome to Hotelworld ai'
					currentStep={step}
					maxSteps={Object.keys(ESteps).length / 2}
					onSkip={handleSkip}
					onNextClickEvent={handleNext}
				>
					<>
						<AuthChatInput />
						<StayUpdated />
					</>
				</TemplateInvitation>
			}
			{step === ESteps.SEARCH_IT && 
				<TemplateInvitation
					headerTitle='Enhanced AI Search'
					titlePrefix='Search'
					title='it'
					description='Just type any question about procedures or company rules and Sofia will help you find the answer'
					currentStep={step}
					maxSteps={Object.keys(ESteps).length / 2}
					onSkip={handleSkip}
					onNextClickEvent={handleNext}
				>
					<>
						<AuthChatInput />
						<StayUpdated />
					</>
				</TemplateInvitation>
			}
			{step === ESteps.STAY_UPDATED && 
				<TemplateInvitation
					headerTitle='News and company updates'
					titlePrefix='Stay'
					title='Updated'
					description='Keep up to speed with the latest company news'
					currentStep={step}
					maxSteps={Object.keys(ESteps).length / 2}
					onSkip={handleSkip}
					onNextClickEvent={handleNext}
				>
					<>
						<AuthChatInput />
						<StayUpdated />
					</>
				</TemplateInvitation>
			}
			{step === ESteps.ASK_AI && 
				<TemplateInvitation
					headerTitle='AI Chat Widget'
					titlePrefix='Ask Sofia'
					title='to search for you'
					description='You’ll get a quick answer and a link to the source on your company’s drives.'
					currentStep={step}
					maxSteps={Object.keys(ESteps).length / 2}
					onSkip={handleSkip}
					onNextClickEvent={handleNext}
				>
					<ChatContent intro />
				</TemplateInvitation>
			}
			{step === ESteps.SAVED && 
				<TemplateInvitation
					headerTitle='History'
					titlePrefix='Saved'
					title='in history'
					description='All your questions are saved in your history for fast reference in the future.'
					currentStep={step}
					maxSteps={Object.keys(ESteps).length / 2}
					onSkip={handleSkip}
					onNextClickEvent={handleNext}
				>
					<ChatHistory />
				</TemplateInvitation>
			}
			{step === ESteps.PERSONALIZE && 
				<TemplateInvitation
					headerTitle='Home: Saved questions'
					titlePrefix='Feedback'
					title='to improve'
					description='Didn’t get what you were expecting. Let Sofia know so that she can improve her own understanding or let your colleagues know what’s not clear in the policies.'
					currentStep={step}
					maxSteps={Object.keys(ESteps).length / 2}
					onSkip={handleSkip}
					onNextClickEvent={handleNext}
				>
					<ChatContent intro />
				</TemplateInvitation>
			}
			{step === ESteps.ASK_QUESTIONS && 
				<TemplateInvitation
					headerTitle='Frequently asked questions'
					titlePrefix='Ask'
					title='questions'
					description='In FAQs you’ll find the questions you and your colleagues ask most frequently.'
					currentStep={step}
					maxSteps={Object.keys(ESteps).length / 2}
					onSkip={handleSkip}
					onNextClickEvent={handleNext}
				>
					<Faqs />
				</TemplateInvitation>
			}
		</>
		
	)
}

export default Invitation;